import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { ShareRegisterFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { ShareRegisterRejectFormContainerProps } from "models/propTypes/shareRegisterPropTypes";
import { UploadedFile } from "models/utilTypes/fileUtilsTypes";
//#endregion
//#region components
import ShareRegisterRejectForm from "./rejectForm";
import { useShareRegisterService } from "serviceHooks";
//#endregion
import * as Yup from "yup";

const ShareRegisterRejectFormContainer: ForwardRefRenderFunction<FormHandles, ShareRegisterRejectFormContainerProps> = (
  props,
  ref
) => {
  const shareRegisterService = useShareRegisterService();
  const validationSchema = Yup.object<ShareRegisterFormTypes.Deny>().shape({
    message: Yup.string(),
    filesToUpload: Yup.array()
      .max(1)
      .of(
        Yup.object<UploadedFile>({
          contentType: Yup.string(),
          fileName: Yup.string(),
          fileSize: Yup.number(),
          data: Yup.string(),
        })
      )
      .min(1, TranslationKeys.Validations.Required)
      .required(TranslationKeys.Validations.Required),
  });

  const handleSubmit = (values: ShareRegisterFormTypes.Deny) => {
    const attachment = values.filesToUpload?.[0];
    return shareRegisterService.rejectShareRegisterConfirmation(props.id, {
      comment: values.message,
      attachment: attachment
        ? {
            ...attachment,
            fileId: attachment.id?.toString(),
          }
        : undefined,
    });
  };

  return (
    <ShareRegisterRejectForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={{}}
      handleSubmit={handleSubmit}
    />
  );
};

export default forwardRef(ShareRegisterRejectFormContainer);
